/* eslint-disable react/jsx-no-bind */
/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { connect } from 'react-redux';
import { history } from 'store';
import Spinner from 'components/spinner/spinner';
import SpinnerButton from 'components/spinner-button/spinner-button';
import GeneralError from 'components/general-error/general-error';
import { InvoiceService, EmploymentCertificateService, Utils } from 'frilans-finans';
import DatepickerRange from 'components/datepicker-range/datepicker-range';

export class EmployerCertificates extends React.Component {

  static propTypes = {
    dateFilter: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      fetchingInvoices: false,
      fetchingMore: false,
      fetchError: false,
      posting: false,
      postError: false,
      postSuccess: false,
      invoices: [],
      selectedInvoices: [],
      showPreview: false,
      previewInvoice: null,
      checkAll: false,
      size: 25,
      meta: {
        currentPage: 0
      },
      pendingRequest: null,
      orderType: 'web',
      datePeriodType: 'workdates',
      showOrderTypeSection: false
    };

    this.fetchInvoices = this.fetchInvoices.bind(this);
    this.orderEmployerCerts = this.orderEmployerCerts.bind(this);
    this.onClick = this.onClick.bind(this);
    this.checkAll = this.checkAll.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.onChangeOrderType = this.onChangeOrderType.bind(this);
    this.onChangeDatePeriodType = this.onChangeDatePeriodType.bind(this);
    this.setShowOrderTypeSection = this.setShowOrderTypeSection.bind(this);
  }

  componentWillUnmount () {
    if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
      this.state.pendingRequest.cancel();
    }
  }

  rememberState () {
    this.setState({
      posting: false,
      postError: false,
      postSuccess: false
    });

    localStorage.setItem(
      'employmentCertificateSavedState',
      JSON.stringify(this.state)
    );
  }

  componentWillMount () {
    const rehydrate = JSON.parse(localStorage.getItem('employmentCertificateSavedState'));
    this.setState(rehydrate);
  }

  componentWillReceiveProps (nextProps) {
    const newStartDate = nextProps.dateFilter.startDate !== this.props.dateFilter.startDate;
    const newEndDate = nextProps.dateFilter.endDate !== this.props.dateFilter.endDate;

    if ((newStartDate || newEndDate) && this.state.datePeriodType === 'invoices') {
      this.props = nextProps;

      this.setState({
        fetchingMore: true,
        invoices: [],
        selectedInvoices: [],
        fetchingInvoices: true,
        meta: {
          currentPage: 0
        }
      }, this.fetchInvoices);
    }
  }

  onChangeDatePeriodType (event) {
    if (event.currentTarget.value === 'invoices') {
      this.fetchInvoices();
    }

    this.setState({
      datePeriodType: event.currentTarget.value
    });
  }

  onChangeOrderType (event) {
    this.setState({
      orderType: event.currentTarget.value
    });
  }

  setShowOrderTypeSection (shouldShow) {
    this.setState({
      showOrderTypeSection: shouldShow,
      postSuccess: false
    });
  }

  goToSingleEmploymentCertificate (invoiceId) {
    this.rememberState();
    history.push(`/economy/employercertificates/${invoiceId}`);
  }

  fetchInvoices () {
    this.setState({
      fetchingMore: true
    });

    let pendingRequest = InvoiceService.getForEmployerCertificates(
      this.props.dateFilter,
      this.state.meta.currentPage + 1,
      this.state.size);
    pendingRequest.promise
      .then(this.handleResponse.bind(this))
      .catch(error => {
        if (error.response !== undefined) {
          this.setState({
            fetchError: true
          });
        }
      });

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  handleResponse (response) {
    let selected = [];

    // Store all indexes with true/false for checked
    for (let i = 0; i < response.collection.length; i++) {
      selected[i] = false;
    }

    this.setState({
      fetchingMore: false,
      fetchingInvoices: false,
      fetchError: false,
      invoices: this.state.invoices.concat(response.collection),
      selectedInvoices: this.state.selectedInvoices.concat(selected),
      meta: response.meta
    });
  }

  checkAll (e) {
    this.setState({
      checkAll: !this.state.checkAll
    }, () => {
      let selected = this.state.selectedInvoices;
      let value = this.state.checkAll;

      // Set all checkboxes to true or false
      for (let i = 0; i < selected.length; i++) {
        selected[i] = value;
      }

      this.setState({
        selectedInvoices: selected
      });
    });
  }

  onClick (e) {
    let index = e.target.value;
    let selected = this.state.selectedInvoices;

    selected[index] = !this.state.selectedInvoices[index];

    this.setState({
      selectedInvoices: selected
    });
  }

  orderEmployerCerts () {
    let invoices = [];
    let request = null;
    const { datePeriodType, orderType, posting } = this.state;

    if (!posting) {
      for (let i = 0; i < this.state.selectedInvoices.length; i++) {
        if (this.state.selectedInvoices[i]) {
          invoices.push(parseInt(this.state.invoices[i].id));
        }
      }

      if (datePeriodType === 'invoices' && invoices.length > 0) {
        request = EmploymentCertificateService.createFromInvoices(invoices, orderType);
      } else if (datePeriodType === 'workdates') {
        const { startDate, endDate } = this.props.dateFilter;

        request = EmploymentCertificateService.createFromWorkPeriod(startDate, endDate, orderType);
      } else {
        return;
      }

      this.setState({
        posting: true,
        postError: false,
        postSuccess: false
      });

      request.then(this.handleSuccess.bind(this))
        .catch(this.handleError.bind(this));
    }
  }

  handleSuccess () {
    this.setState({
      posting: false,
      postSuccess: true,
      postError: false
    });
  }

  handleError () {
    this.setState({
      posting: false,
      postError: true,
      postSuccess: false
    });
  }

  renderLoader () {
    return (
      <div className='loader-wrapper'>
        <Spinner />
      </div>
    );
  }

  renderNoResult () {
    return (
      <p className='info'><Translate content='NO_EMPLOYER_CERTIFICATES'/></p>
    );
  }

  renderPostError () {
    if (this.state.postError) {
      return (<GeneralError/>);
    }
  }

  renderPostSuccess () {
    if (this.state.postSuccess || this.state.posting) {
      return (<p className="info"><Translate content='EMP_CERT_SUCCESS'/></p>);
    }
  }

  renderRow (invoice, i) {
    let gross = 0;
    let payPerHour = 0;

    for (let salary of invoice.salaries) {
      if (parseInt(salary.userId) === parseInt(this.props.user.id) &&
      salary.typeId === 1 && [1, 2, 3, 4].includes(salary.categoryId)) {
        gross += salary.grossAmount;
      }
    }

    if (Utils.isNumeric(invoice.hours)) {
      payPerHour = Math.round(gross / invoice.hours);
    }

    const sortedWorkDates = invoice.invoiceDates.sort((date1, date2) => date1.date - date2.date);

    const firstWorkDate = sortedWorkDates[0].date;
    const lastWorkDate = sortedWorkDates[sortedWorkDates.length - 1].date;

    return (
      <tr className='employment-certificate-row' key={i}>
        <td className='col-check employment-certificate-row-checkbox'>
          <input id={'invoice-' + invoice.id} type='checkbox'
            value={i} checked={this.state.selectedInvoices[i]} onClick={this.onClick}
            onChange={e => {}}
            name={'invoice-' + invoice.id} />
          <label htmlFor={'invoice-' + invoice.id}><span></span></label>
        </td>
        <td
          onClick={() => this.goToSingleEmploymentCertificate(invoice.id)}
          className='col-ordernr'>{invoice.id}</td>
        <td
          onClick={() => this.goToSingleEmploymentCertificate(invoice.id)}
          className='col-customer'>{invoice.customer.name}</td>
        <td
          onClick={() => this.goToSingleEmploymentCertificate(invoice.id)}
          className='col-created'>
          {`${Utils.formatDate(firstWorkDate)} - ${Utils.formatDate(lastWorkDate)}`}
        </td>
        <td
          onClick={() => this.goToSingleEmploymentCertificate(invoice.id)}
          className='col-gross-h'>
          {payPerHour + ' ' + proxyCounterpart('DEFAULT_CURRENCY_NAME_SHORT_OTHER')}
        </td>
      </tr>
    );
  }

  renderTable () {
    return (
      <div>
        <div className='table-wrapper'>
          <table className='standard-table'>
            <thead>
              <tr>
                <th className='col-check employment-certificate-row-checkbox'>
                  <input id='check-all' type='checkbox' name='check-all'
                    checked={this.state.checkAll} onClick={this.checkAll} />
                  <label htmlFor='check-all'><span></span></label>
                </th>
                <th className='col-ordernr'><Translate content='ORDER_NR'/></th>
                <th className='col-customer'><Translate content='CUSTOMER'/></th>
                <th className='col-created'><Translate content='WORK_PERIOD'/></th>
                <th className='col-gross-h'><Translate content='GROSS_SALARY_H'/></th>
              </tr>
            </thead>
            <tbody>
              {this.state.invoices.map(this.renderRow.bind(this))}
            </tbody>
          </table>
          {this.renderShowMoreBtn()}
        </div>
      </div>
    );
  }

  renderTableWrapper () {
    return (
      <div>
        {this.renderTable()}
      </div>
    );
  }

  renderNextButton () {
    const noSelectedInvoices = this.state.datePeriodType === 'invoices' &&
      !this.state.selectedInvoices.some(inv => !!inv);

    return (
      <SpinnerButton text={proxyCounterpart('NEXT')}
        disabled={noSelectedInvoices && !this.state.fetchingMore}
        loading={this.state.fetchingMore} classes='btn submit-btn'
        callback={() => this.setShowOrderTypeSection(true)}/>
    );
  }

  renderOrderButton () {
    return (
      <SpinnerButton text={proxyCounterpart('ORDER_EMP_CERT')}
        loading={this.state.posting} classes='btn submit-btn' callback={this.orderEmployerCerts}/>
    );
  }

  renderShowMoreBtn () {
    if (this.state.meta.currentPage < this.state.meta.totalPages && !this.state.fetchingInvoices) {
      return (
        <div className='show-more-btn-wrapper'>
          <SpinnerButton text={proxyCounterpart('SHOW_MORE')} graySpinner='true'
            loading={this.state.fetchingMore} classes='btn white show-more' callback={this.fetchInvoices}/>
        </div>
      );
    }

    return false;
  }

  getContentForInvoices () {
    if (this.state.datePeriodType === 'invoices') {
      if (this.state.fetchError) {
        return (<GeneralError />);
      }
      if (this.state.fetchingInvoices) {
        return this.renderLoader();
      }
      if (this.state.invoices.length === 0) {
        return this.renderNoResult();
      }

      return this.renderTableWrapper();
    }
  }

  renderDatePeriodCheckboxes () {
    return (
      <div className="date-period-type-input">
        <input id='date-period-type-workdates' name='date-period-type' type='radio' value={'workdates'}
          checked={this.state.datePeriodType === 'workdates'}
          onChange={this.onChangeDatePeriodType}/>
        <label htmlFor='date-period-type-workdates'>
          <span></span><Translate content='EMPLOYER_CERTIFICATE_PERIOD_WORKDATES'/>
        </label>
        <br />
        <br />

        <input id='date-period-type-invoices' name='date-period-type' type='radio' value={'invoices'}
          checked={this.state.datePeriodType === 'invoices'}
          onChange={this.onChangeDatePeriodType}/>
        <label htmlFor='date-period-type-invoices'>
          <span></span><Translate content='EMPLOYER_CERTIFICATE_PERIOD_INVOICES'/>
        </label>
      </div>
    );
  }

  renderOrderCheckboxes () {
    return (
      <div className="order-type-input">
        <input id='order-type-web' name='order-type-web' type='radio' value={'web'}
          checked={this.state.orderType === 'web'}
          onChange={this.onChangeOrderType}/>
        <label htmlFor='order-type-web'>
          <span></span>
          <span
            dangerouslySetInnerHTML={{__html: proxyCounterpart('EMPLOYER_CERTIFICATE_BY_AI_NU')}}>
          </span>
        </label>
        <br />
        <br />

        <input id='order-type-mail' name='order-type-mail' type='radio' value={'mail'}
          checked={this.state.orderType === 'mail'}
          onChange={this.onChangeOrderType}/>
        <label htmlFor='order-type-mail'>
          <span></span><Translate content='EMPLOYER_CERTIFICATE_BY_MAIL'/>
        </label>
      </div>
    );
  }

  renderDatePeriodSection () {
    if (!this.state.postSuccess && !this.state.posting) {
      if (!this.state.showOrderTypeSection) {
        return (
          <span>
            <h2><Translate content='EMPLOYER_CERTIFICATE_CHOOSE_PERIOD'/></h2>

            <DatepickerRange />
            {this.renderDatePeriodCheckboxes()}

            {this.getContentForInvoices()}

            {this.renderNextButton()}
          </span>
        );
      } else {
        return (
          <h2 className="clickable-header" onClick={() => this.setShowOrderTypeSection(false)}>
            <Translate content='EMPLOYER_CERTIFICATE_CHOOSE_PERIOD'/> - &#10003;
          </h2>
        );
      }
    }
  }

  renderOrderSection () {
    if (!this.state.postSuccess && !this.state.posting) {
      if (this.state.showOrderTypeSection) {
        return (
          <div>
            <h2><Translate content='EMPLOYER_CERTIFICATE_ORDERING'/></h2>
            {this.renderOrderCheckboxes()}
            {this.renderOrderButton()}
          </div>
        );
      } else {
        return (
          <p className='info'><Translate content='EMPLOYER_CERTIFICATE_ORDERING'/></p>
        );
      }
    }
  }

  render () {
    return (
      <div className='employer-certificate'>

        <h2><Translate content='EMPLOYER_CERTIFICATE'/></h2>
        <p><Translate content='EMPLOYER_CERTIFICATE_TEXT'/></p>
        <br />
        {this.renderDatePeriodSection()}

        {this.renderOrderSection()}

        {this.renderPostError()}
        {this.renderPostSuccess()}
      </div>
    );
  }

}

function mapStateToProps (state) {
  return {
    dateFilter: state.filters.dateFilter,
    user: state.user
  };
};

export default connect(
  mapStateToProps
)(EmployerCertificates);



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/employer-certificate/employer-certificates.js
 **/